import { Module, VuexModule, getModule } from 'vuex-module-decorators'
import { store } from '@/store'

@Module({ name: 'Config', dynamic: true, store })
class ConfigModule extends VuexModule {
  // TODO
  configs: { key: string; value: any }[] = [
    {
      key: 'resetPasswordQuestion',
      value: ['父亲姓名', '母亲姓名', '高中毕业学校']
    },
    {
      key: 'notice',
      value: [
        [
          '本网站未委托任何第三方提供报名服务, 除本网站外。',
          '任何宣称进行考试报名的活动均与本网站无关。'
        ],
        [
          '考生不得以他人身份或委托他人进行报名，否则，需承担由此所造成的相关责任。'
        ],
        [
          '考生所填写的个人信息资料需真实准确。',
          '本网站在考生确认打印个人信息前会提供审核更正的机会。',
          '由于考生填写个人信息错误导致报名延误或影响正常参加考试，由考生本人承担全部责任。'
        ],
        [
          '本网站要求考生以证件号码和考生自定义密码作为登录的依据（密钥）。',
          '考生应妥善保管自己的证件和密码，否则，因他人盗用登录密钥造成后果的，本网站不承担任何责任'
        ],
        [
          '考试报名的最终信息以现场确认后的准考证为准。',
          '考试成绩以书面通知书为准。'
        ]
      ]
    },
    /*{
      key: 'entries',
      value: [
        {
          name: 'normal-student',
          title: '免费师范生',
          description: '2020年免费师范生报名',
          disabled: true,
          hidden: true
        },
        {
          name: 'junior-to-higher-student',
          title: '专升本',
          description: '2020年专升本报名',
          disabled: true,
          hidden: true
        },
        {
          name: 'taiwan-student',
          title: '台湾地区入学申请',
          description: '台湾地区高中毕业生入学申请',
          disabled: true,
          hidden: true
        },
        {
          name: 'reselect-major',
          title: '调整专业申请',
          description: '2020级新生单科优异新生调整专业申请',
          disabled: true,
          hidden: true
        },
        {
          name: 'second-degree',
          title: '第二学士学位招生',
          description: '2022年上海师范大学第二学士学位招生报名',
          disabled: true,
          hidden: true
        },
        {
          name: 'art-student',
          title: '艺术类',
          description: '2020年艺术类报名',
          disabled: true,
          hidden: true
        },
        {
          name: 'art-mail',
          title: '书法学校考作品邮寄登记',
          description: '书法学校考作品邮寄登记',
          disabled: true,
          hidden: true,
        },
        {
          name: 'chongming-student',
          title: '崇明定向',
          description: '崇明区定向培养',
          disabled: false,
          hidden: false,
        }
      ]
    },*/
    {
      key: 'chongming-student',
      value: {
        notice: '崇明区定向培养报名',
        title: '年上海师范大学崇明区定向培养报名',
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          [
            '请上传本人近三个月内正面、免冠、无妆、彩色一寸电子证件照，JPG/PNG 格式，大小 1M 以内。（建议使用chrome浏览器或360浏览器急速模式）'
          ],
          ['此表须打印一份，本人用黑色水笔签字。'],
          ['请如实填写本表，否则将取消申请和录取资格。']
        ]
      }
    },
    {
      key: 'art-mail',
      value: {
        notice: '书法学校考作品邮寄登记',
        title: '书法学校考作品邮寄登记',
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          ['请如实填写本表，否则将取消申请和录取资格。'],
          ['上传的照片大小不超过5M。']
        ]
      }
    },
    {
      key: 'normal-student',
      value: {
        notice: '2020年上海师范大学免费师范生报名须知',
        title: '2020年上海师范大学免费教育师范生报名推荐表',
        majors: ['A', 'B', 'C', 'D', 'E', 'LongLongLongLongLongLongMajor'],
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          [
            '现场报名请携带：',
            [
              '所读高校教务处或学生处盖章的应届毕业生毕业证明原件。',
              '大学英语四级考试成绩达 425 分（含）以上证书的原件；上海市或全国高等学校计算机等级考试以及合格证书的原件。提交上述证明或证书复印件一套。',
              '身份证、学生证原件、近期一寸正面免冠报名照两张；报名费，考试费。'
            ],
            '退役士兵不受上述证书限制，确认时需携带身份证、专科（高职）毕业证（毕业证明）和士兵退役证三证原件，并提供复印件一份'
          ],
          [
            '现场报名时间：4月22日 9:00~15:30',
            '现场报名地点：上海师范大学（桂林路100号）'
          ]
        ]
      }
    },
    {
      key: 'art-student',
      value: {
        notice: '年上海师范大学艺术类报名须知',
        title: '年上海师范大学艺术类报名推荐表',
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          [
            '现场报名请携带：',
            [
              '所读高校教务处或学生处盖章的应届毕业生毕业证明原件。',
              '大学英语四级考试成绩达 425 分（含）以上证书的原件；上海市或全国高等学校计算机等级考试以及合格证书的原件。提交上述证明或证书复印件一套。',
              '身份证、学生证原件、近期一寸正面免冠报名照两张；报名费，考试费。'
            ],
            '退役士兵不受上述证书限制，确认时需携带身份证、专科（高职）毕业证（毕业证明）和士兵退役证三证原件，并提供复印件一份'
          ],
          [
            '现场报名时间：4月22日 9:00~15:30',
            '现场报名地点：上海师范大学（桂林路100号）'
          ]
        ]
      }
    },
    {
      key: 'junior-to-higher-student',
      value: {
        notice: '2020年上海师范大学专升本报名须知',
        title: '2020年上海师范大学专升本报名推荐表',
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          [
            '现场报名请携带：',
            [
              '所读高校教务处或学生处盖章的应届毕业生毕业证明原件。',
              '大学英语四级考试成绩达 425 分（含）以上证书的原件；上海市或全国高等学校计算机等级考试以及合格证书的原件。提交上述证明或证书复印件一套。',
              '身份证、学生证原件、近期一寸正面免冠报名照两张；报名费，考试费。'
            ],
            '退役士兵不受上述证书限制，确认时需携带身份证、专科（高职）毕业证（毕业证明）和士兵退役证三证原件，并提供复印件一份'
          ],
          [
            '现场报名时间：4月22日 9:00~15:30',
            '现场报名地点：上海师范大学（桂林路100号）'
          ]
        ]
      }
    },
    {
      key: 'reselect-major',
      value: {
        notice: '2020级新生重选专业须知',
        title: '2020级单科优异新生调整专业申请表',
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          ['此表须打印一份，本人和家长用黑色水笔签字。新生报到当天交教务处。'],
          [
            '如生源地所在省级考试院不提供科目的分数排位，将由教务处组织研讨，统一划定单科线。'
          ]
        ]
      }
    },
    {
      key: 'taiwan-student',
      value: {
        notice: '台湾地区高中毕业生入学申请',
        title: '上海师范大学2021年台湾地区高中毕业生入学申请表',
        details: [
          ['本表为 2021 年招收台湾高中毕业生所用。'],
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          [
            '请上传本人近三个月内正面、免冠、无妆、彩色一寸电子证件照，JPG/PNG 格式，大小 1M 以内。'
          ],
          [
            '本表请用电脑填写后打印（简体或繁体字皆可），另需手写签名“申请人声明”。'
          ],
          ['请如实填写本表，否则将取消申请和录取资格。']
        ]
      }
    },
    {
      key: 'second-degree',
      value: {
        notice: '第二学士学位报名',
        title: '年上海师范大学第二学士学位招生报名',
        details: [
          ['填写完毕后点击"保存"按钮保存表格。'],
          ['考生保存表格后可以修改内容，修改完毕请务必再次点击保存按钮。'],
          ['每位考生只可填报1个专业志愿。'],
          [
            '请上传本人近三个月内正面、免冠、无妆、彩色一寸电子证件照，JPG/PNG 格式，大小 1M 以内。'
          ],
          ['此表须打印一份，本人用黑色水笔签字。'],
          ['请如实填写本表，否则将取消申请和录取资格。']
        ],
        choices: ['英语（师范）', '数学与应用数学（师范）', '思想政治教育']
      }
    },
    {
      key: 'national',
      value: [
        '汉族',
        '蒙古族',
        '回族',
        '藏族',
        '维吾尔族',
        '苗族',
        '彝族',
        '壮族',
        '布依族',
        '朝鲜族',
        '满族',
        '侗族',
        '瑶族',
        '白族',
        '土家族',
        '哈尼族',
        '哈萨克族',
        '傣族',
        '黎族',
        '傈僳族',
        '佤族',
        '畲族',
        '拉祜族',
        '水族',
        '东乡族',
        '纳西族',
        '景颇族',
        '柯尔克孜族',
        '土族',
        '达斡尔族',
        '仫佬族',
        '羌族',
        '布朗族',
        '撒拉族',
        '毛南族',
        '仡佬族',
        '锡伯族',
        '阿昌族',
        '普米族',
        '塔吉克族',
        '怒族',
        '乌孜别克族',
        '俄罗斯族',
        '鄂温克族',
        '德昂族',
        '保安族',
        '裕固族',
        '京族',
        '塔塔尔族',
        '独龙族',
        '鄂伦春族',
        '赫哲族',
        '门巴族',
        '珞巴族',
        '基诺族',
        '高山族'
      ]
    },
    {
      key: 'major',
      value: [
        '表演',
        '播音与主持艺术',
        '档案学',
        '地理科学(师范)',
        '地理科学类',
        '电子信息工程(中美合作)',
        '电子信息类',
        '雕塑',
        '动画',
        '法学',
        '法语',
        '工程管理',
        '工商管理类',
        '公共管理类',
        '公共事业管理(师范)',
        '古典文献学',
        '广播电视编导',
        '广告学(中法合作)',
        '汉语国际教育',
        '汉语言文学(师范)',
        '汉语言文学(文科基地)',
        '化学(师范)',
        '化学类',
        '环境工程',
        '绘画',
        '机械设计制造及其自动化(中美合作制造工程技术)',
        '计算机科学与技术(师范)',
        '计算机科学与技术(中法合作)',
        '教育技术学',
        '教育学',
        '金融学类',
        '经济学',
        '经济学(中法合作)',
        '经济学(中美合作)',
        '酒店管理',
        '科学教育',
        '历史学(师范)',
        '录音艺术',
        '旅游管理',
        '旅游管理类',
        '美术学(师范)',
        '汽车服务工程(中德合作)',
        '人力资源管理',
        '日语',
        '设计学类',
        '社会工作',
        '社会体育指导与管理',
        '摄影',
        '生物科学(师范)',
        '生物科学类',
        '食品安全与检测',
        '世界史',
        '数学类',
        '数学类(数学金融人工智能实验班)',
        '数学与应用数学(师范)',
        '思想政治教育',
        '体育教育',
        '土木工程(道桥工程)',
        '土木工程(中英合作)',
        '文化产业管理',
        '舞蹈学',
        '物理学',
        '物理学(师范)',
        '戏剧影视文学',
        '小学教育',
        '新闻传播学类',
        '学前教育',
        '音乐表演',
        '音乐表演(中俄合作)',
        '音乐学(师范)',
        '应用心理学',
        '英语',
        '英语(师范)',
        '预科',
        '园艺(中荷合作)',
        '哲学',
        '中国画'
      ]
    },
    {
      key: 'college',
      value: [
        '对外汉语学院',
        '化学与材料科学学院',
        '环境与地理科学学院',
        '建筑工程学院',
        '教育学院',
        '旅游学院',
        '马克思主义学院',
        '美术学院',
        '人文学院',
        '商学院',
        '生命科学学院',
        '数理学院',
        '体育学院',
        '外国语学院',
        '信息与机电工程学院',
        '音乐学院',
        '影视传媒学院',
        '哲学与法政学院'
      ]
    }
  ]
}

export const ConfigStore = getModule(ConfigModule)
